import styled, { css } from 'styled-components';

import { screen } from '@styles/mixins/breakpoints';
import { getUserImportanceColor } from '@styles/mixins/userImportance';
import { fonts } from '@styles/variables';

const StyledListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ gapBelow }) => (gapBelow && '48px')};
  background-color: ${({ userImportance }) => getUserImportanceColor(userImportance)};
`;

const StyledListTitle = styled.h2`
  padding: 48px 0 ${({ withSubtitle }) => (withSubtitle ? '8px' : '48px')};
  font: 32px/48px 'gt-america-extended-bold', Arial, sans-serif;
  text-align: center;

  ${screen.l(css`
    padding: 44px 0 8px;
    font-size: 24px;
  `)}
`;

const StyledListSubtitle = styled.div`
  max-width: 1088px;
  padding: 0 32px 48px;
  margin: 0 auto;
  font: 16px/24px ${fonts.fontPrimaryRegular};
  text-align: center;

  ${screen.l(css`
    padding: 0 16px 48px;
  `)}
`;

export default { StyledListContainer, StyledListTitle, StyledListSubtitle };
